import { render, staticRenderFns } from "./ProgressUpload.vue?vue&type=template&id=5052d942&scoped=true&"
import script from "./ProgressUpload.vue?vue&type=script&lang=js&"
export * from "./ProgressUpload.vue?vue&type=script&lang=js&"
import style0 from "./ProgressUpload.vue?vue&type=style&index=0&id=5052d942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5052d942",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5052d942')) {
      api.createRecord('5052d942', component.options)
    } else {
      api.reload('5052d942', component.options)
    }
    module.hot.accept("./ProgressUpload.vue?vue&type=template&id=5052d942&scoped=true&", function () {
      api.rerender('5052d942', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/LeaderBoard/components/ProgressUpload.vue"
export default component.exports